// Modules
import cn from 'classnames'

// Types
import type { TBadgeProps } from './Badge.type';

// Constants
import { BADGE_DEFAULT_PROPS } from './Badge.constant';

// Styles
import styles from './styles.module.scss'

const Badge = (props: TBadgeProps) => {
  const {
    className,
    color = BADGE_DEFAULT_PROPS.color,
    label,
    size = BADGE_DEFAULT_PROPS.size,
    ...restProps
  } = props

  const badgeCN = cn(styles.legion_badge, className, styles[color!], styles[size!])

  return (
    <div className={badgeCN} {...restProps}>
      {label && (
        <p className={styles.label}>{label}</p>
      )}
    </div>
  )
}

export default Badge
